
import VideoSlider from './VideoSlider.js';


window.addEventListener('DOMContentLoaded', (event) => {


	let videoSliders = document.querySelectorAll( '.wp-block-whoblock-video-slider' );

	videoSliders.forEach(function ( elt, index) {

		let videoSlider = new VideoSlider( elt );

	});

});
